import type { PackageUsedBy } from '@openx/types/package/PackageHookTypes.ts';

export const isPackageUsedBy = (packageUid: string, packagesUsedBy: PackageUsedBy[]) => {
  const usedByEntry = packagesUsedBy.find(item => item.uid === packageUid);

  if (!usedByEntry) {
    return { deals: false, floors: false, dealsOrFloors: false };
  }

  const { deals_referenced, floorrules_referenced } = usedByEntry;

  const deals = Number(deals_referenced) > 0;
  const floors = Number(floorrules_referenced) > 0;

  return { deals, floors, dealsOrFloors: deals || floors };
};
